import type { Action, Zone } from '@mezha/api'

/** The unsent choice of a round, kept per tab so a reload restores it. */
type BlowZone = Exclude<Zone, ''>
export type Draft = {
  round: number; attack: BlowZone | null; defend: BlowZone | null; action: Action; target: string | null
  /** The skill of the combat set for action «skill», the second guarded zone of a stance, the ally of a sign. */
  skill: string | null; defend2: BlowZone | null; ally: string | null
}

const key = (battleId: string) => `battleDraft:${battleId}`
const ACTIONS: Action[] = ['strike', 'onslaught', 'charm', 'rest', 'skill']

export function loadDraft(battleId: string, round: number): Draft {
  const empty: Draft = { round, attack: null, defend: null, action: 'strike', target: null, skill: null, defend2: null, ally: null }
  try {
    const raw = sessionStorage.getItem(key(battleId))
    if (!raw) return empty
    const d = JSON.parse(raw) as Partial<Draft>
    if (d.round !== round) return { ...empty, target: d.target ?? null }
    // A draft saved by an older client may carry no action: it is a plain strike.
    const action = ACTIONS.includes(d.action as Action) && (d.action !== 'skill' || d.skill) ? (d.action as Action) : 'strike'
    return { ...empty, ...d, action, skill: action === 'skill' ? d.skill ?? null : null }
  } catch {
    return empty
  }
}

export function saveDraft(battleId: string, d: Draft): void {
  try {
    sessionStorage.setItem(key(battleId), JSON.stringify(d))
  } catch {
    /* private mode */
  }
}

export function dropDraft(battleId: string): void {
  try {
    sessionStorage.removeItem(key(battleId))
  } catch {
    /* ignore */
  }
}
